import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GameIconComponent } from '@core/components/game-icon/game-icon.component';
import { InfoModalMaxPayoutComponent } from '@core/components/game-board/info-modal-max-payout/info-modal-max-payout.component';

@Component({
  selector: 'app-towers-info-modal',
  imports: [GameIconComponent, InfoModalMaxPayoutComponent],
  templateUrl: './towers-info-modal.component.html',
  styleUrl: './towers-info-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class TowersInfoModalComponent {
  readonly MAX_PAYOUT = 100_000;
}
